
import React from 'react';

import {  faHome } from '@fortawesome/free-solid-svg-icons';
import FAQComponent from "../../components/FAQComponent";
import Documentation from "../../components/Documentation";
import { Col, Row, Card,Breadcrumb } from '@themesberg/react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom';
export default () => {
    const text = 'One \n Two \n Three';
    return (
      <>
      <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center mt-4">
      <div className="d-block mb-4 mb-md-0">
        <Breadcrumb className="d-none d-md-inline-block" listProps={{ className: "breadcrumb-dark breadcrumb-transparent" }}>
          <Breadcrumb.Item><Link to={"/dashboard/overview"}><FontAwesomeIcon icon={faHome} /></Link></Breadcrumb.Item>
         
          <Breadcrumb.Item active>FAQs</Breadcrumb.Item>
        </Breadcrumb>
        <h4>FAQs</h4>
      </div>
      
    </div>
      <Card border="light" className="bg-white  mb-4 ">
        
      <Card.Body>
        <p><b>Applying For A Merchant Account </b>
        </p>
      <FAQComponent
    defaultKey="panel-1"
    data={[
      {
        id: 1,
        eventKey: "panel-1",
        title: "How Do I Apply For A Merchant Account?",
        description: "You can apply for a merchant account via our online application. It will take about 5 minutes to complete."
       
    },
      {
        id: 2,
        eventKey: "panel-2",
        title: "What are the Steps Required for an Application?",
        description: "Step 1: Complete the online application. Step 2: Send in the required additional documents.Step 3: You’ll be emailed a full proposal for eSignature.Step 4: Await underwriting approval."
      },
      {
        id: 3,
        eventKey: "panel-3",
        title: "What Additional Documents Are Needed For My Application?",
        description: "US High Risk Merchant Account If you are applying for a US merchant account, you will need to submit with your application or via email following documents:"
      }
    ]} />
    <hr />
    <p className='mt-3'><b>Merchant Account Approvals
    </b>
        </p>
      <FAQComponent
    
    data={[
      {
        id: 4,
        eventKey: "panel-4",
        title: "How Long After Applying Until I Get Approved?",
        description: "US high risk merchant accounts:You’ll be pre-approved within 24 hours, and generally fully complete underwriting in 2 to 4 days.Offshore high risk merchant accounts:You’ll be pre-approved within 24 hours, and generally fully complete underwriting in 3 to 6 day"
       
    },
      {
        id: 5,
        eventKey: "panel-5",
        title: "How Long After Applying Before I Can Accept Payments?",
        description: "US high risk merchant accounts:Once underwriting has approved your account, you’ll be able to accept payments within 24 hours.Offshore high risk merchant accounts:Once underwriting has approved your account, you’ll be able to accept payments within 24 to 48 hours."
      }
    ]} />
    
    <hr />
    <p className='mt-3'><b>Who We Accept For Merchant Accounts

    </b>
        </p>
      <FAQComponent
    
    data={[
      {
        id: 6,
        eventKey: "panel-6",
        title: "What Types of Businesses Do You Accept?",
        description: "We accept low, medium and high risk businesses, both in the US and offshore. To be accepted, businesses must be legally operating and in good standing with their bank."
       
    },
      {
        id: 7,
        eventKey: "panel-7",
        title: "Can I Get Approved For A Merchant Account With Bad Credit?",
        description: "Yes. We work with dozens of sponsor banks and some are more sensitive to credit scores than others. If you have a bad credit score, have recently declared bankruptcy, etc. we’ll simply establish your merchant account with a sponsor bank which accepts merchants with poor credit scores."
      },
      {
        id: 8,
        eventKey: "panel-8",
        title: "Can I Get Approved For A Merchant Account as a Startup / New Business?",
        description: "Yes. We work with both US and offshore startup businesses. When applying, simply provide the owner’s personal bank statements in lieu of business bank statements."
      }
    ]} />

<hr />
    <p className='mt-3'><b>About Pricing & Terms

    </b>
        </p>
      <FAQComponent
    
    data={[
      {
        id: 9,
        eventKey: "panel-9",
        title: "What is the Discount Rate / Pricing on Blueberry Merchant Accounts?",
        description: "It depends. The discount rate is the percentage of each transaction that the acquiring bank and processor charge for the transaction to be processed. This is determined based on the industry type, the previous e-Check/Credit card processing history of the merchant, the credit rating of the business owner, and a host of other factors.After completing the online application, you will be emailed a contract for your review which will list all pricing details. You can choose to sign and accept the offer, or reject it at that time."
       
    },
      {
        id: 10,
        eventKey: "panel-10",
        title: "What is the Transaction Fee on Blueberry Merchant Accounts?",
        description: "It depends. The transaction fee is a flat fee charged on each transaction that the acquiring bank and processor charge for the transaction to be processed. This will vary based upon the industry, e-Check/Credit card processing history and credit score of the business owner.After completing the online application, you will be emailed a contract for your review which will list all pricing details. You can choose to sign and accept the offer, or reject it at that time."
      },
      {
        id: 11,
        eventKey: "panel-11",
        title: "What is the Rolling Reserve on Blueberry’ Merchant Accounts?",
        description: "It depends. The range is anywhere from 0% to 40%. It depends on your industry, your previous processing history, and your credit score. It is entirely determined by underwriting, once they’ve reviewed your account.Once your merchant account’s rolling reserve has been decided, you’ll be presented with the rolling reserve, at which point you can elect to proceed with the merchant account or decline it.As to what a rolling reserve is, the rolling reserve is an escrow account that the acquiring bank creates to hold a portion of the funds that your company processes via the merchant account. These funds are typically held for 6 months, and then get released to you monthly thereafter. The processor and acquiring bank use rolling reserves to ensure that they are financially covered in the event that there are fraudulent transactions or unpaid chargebacks through your account."
      },
      {
        id: 12,
        eventKey: "panel-12",
        title: "How Long Does it Take To Get Sales Funded Into My Bank Account on Blueberry Merchant Accounts?",
        description: "It depends. The time period between when you make a sale and when the money gets deposited into your business’ bank account is known as the “funding period” and each acquiring bank sets their own funding period. For US merchant accounts, it’s typically 24-72 hours. For Offshore merchant accounts it’s typically weekly."
       
    }
    ]} />

<hr />
    <p className='mt-3'><b>About Chargebacks

    </b>
        </p>
      <FAQComponent
    
    data={[
      {
        id: 13,
        eventKey: "panel-13",
        title: "What is the Chargeback Threshold?",
        description: "The chargeback threshold is the percentage (either in dollars or in the number of sales) that may be ‘charged back’ by your customers before your merchant account becomes in jeopardy of being closed. For a low risk merchant account, that might be 1%, whereas for a high risk merchant account that is generally 2 to 3% for US merchant accounts, and 3 to 10% for offshore merchant accounts.The chargeback threshold applicable to your merchant account is set by the sponsor bank, and therefore will depend on which sponsor bank you work through. We will discuss your individual threshold prior to completing the application process."
       
    },
      {
        id: 14,
        eventKey: "panel-14",
        title: "What is Chargeback Armor?",
        description: "Chargeback Armor is Blueberry’ proprietary integrated chargeback prevention system. It consists of a gateway integrated fraud filter, a customer billing support hotline, chargeback alerts, and integrated chargeback fighting / representment. To learn more visit Chargeback Armor."
      },
      {
        id: 15,
        eventKey: "panel-11",
        title: "Do You Fight Chargebacks For Me?",
        description: "Yes. With Chargeback Armor enabled on your high risk merchant account, you will be provided automatically with chargeback representment services."
      }
    ]} />

      </Card.Body>
    </Card>
   
    </>
   
  
    );
  };